import {
  GET_RESTAURANT_INFO,
  GET_RESTAURANT_INFO_BY_ID,
  GET_RESTAURANT_ITEMS,
  RESET_INFO,
  RESET_ITEMS,
  SINGLE_ITEM,
  SEARCH_ITEM,
  CLEAR_SEARCH,
  SET_FAVORITE_REST,
  SET_MAPPED_REST,
  GET_RESTAURANT_INFO_FOR_LOGGED_IN_USER,
  GET_HOME_PRODUCTS,
  GET_SHOW_MORE_PRODUCTS,
  GET_PRICE_SORTED_PRODUCTS,
  GET_PRICE_SORTED_SHOW_MORE_PRODUCTS
} from "./actionTypes";
//RESET_BACKUP

import { FORCE_RELOAD } from "../helper/actionTypes";

import {
  GET_RESTAURANT_INFO_BY_ID_URL,
  GET_RESTAURANT_INFO_URL,
  GET_RESTAURANT_ITEMS_URL,
  GET_SINGLE_ITEM_URL,
  GET_RESTAURANT_INFO_AND_OPERATIONAL_STATUS_URL,
  ADD_TO_FAVORITE_RESTAURANT_URL,
  GET_FAVORITE_RESTAURANT_FOR_LOGGED_IN_URL,
  ADD_TO_MAPPED_RESTAURANT_URL,
  GET_HOME_PRODUCTS_URL,
  GET_SHOW_MORE_PRODUCTS_URL,
  GET_PRICE_SORTED_PRODUCTS_URL,
  GET_PRICE_SORTED_SHOW_MORE_PRODUCTS_URL,
  GET_ADDRESS_FROM_COORDINATES
} from "../../configs";
import { updateCart } from "../total/actions";
import { getCurrentCartType } from "../../helpers/cartMode";
import { getUserCoords } from "../../components/helpers/storeDistance";

import Axios from "axios";
// import FuzzySearch from "fuzzy-search";
// import { WEBSITE_URL } from "../../configs/website";

// Only the newest store-info request may update the shared restaurant_info.
// This prevents a slow Cart response from overwriting a newer Store response
// after the user navigates back and forth quickly.
let restaurantInfoRequestSequence = 0;

const beginRestaurantInfoRequest = () => ++restaurantInfoRequestSequence;
const isLatestRestaurantInfoRequest = (sequence) =>
  sequence === restaurantInfoRequestSequence;

const attachCustomerCoords = (payload, user, latitude, longitude) => {
  const hasExplicitCoords =
    latitude !== null &&
    latitude !== undefined &&
    latitude !== "" &&
    longitude !== null &&
    longitude !== undefined &&
    longitude !== "";
  const explicitLat = Number(latitude);
  const explicitLng = Number(longitude);
  const coords =
    hasExplicitCoords &&
    Number.isFinite(explicitLat) &&
    Number.isFinite(explicitLng)
      ? { lat: explicitLat, lng: explicitLng }
      : getUserCoords(user);

  if (coords) {
    payload.latitude = coords.lat;
    payload.longitude = coords.lng;
  }

  return payload;
};

export const setSingleItem = (product) => ({
  type: SINGLE_ITEM,
  payload: product,
});

export const getRestaurantInfoAndOperationalStatus = (
  id,
  latitude,
  longitude
) => (dispatch, getState) => {
  const sequence = beginRestaurantInfoRequest();
  const user = getState().user.user;
  const payload = attachCustomerCoords({
    id: id,
  }, user, latitude, longitude);

  return Axios.post(GET_RESTAURANT_INFO_AND_OPERATIONAL_STATUS_URL, payload)
    .then((response) => {
      const restaurant_info = response.data;
      if (!isLatestRestaurantInfoRequest(sequence)) {
        return null;
      }
      return dispatch({ type: GET_RESTAURANT_INFO, payload: restaurant_info });
    })
    .catch(function (error) {
      console.error(error);
      if (!isLatestRestaurantInfoRequest(sequence)) {
        return null;
      }
      if (error.response && error.response.status === 400) {
        const force_reload = true;
        return dispatch({ type: FORCE_RELOAD, payload: force_reload });
      }
    });
};

export const getRestaurantInfo = (slug) => (dispatch, getState) => {
  const sequence = beginRestaurantInfoRequest();
  let user = getState().user.user;
  const payload = {
    token: "",
    user_id: "",
  };
  if (user && user.data) {
    payload.token = user.data.auth_token;
    payload.user_id = user.data.id;
  }
  attachCustomerCoords(payload, user);

  return Axios.post(GET_RESTAURANT_INFO_URL + "/" + slug, payload)
    .then((response) => {
      const restaurant_info = response.data;
      if (!isLatestRestaurantInfoRequest(sequence)) {
        return null;
      }
      return dispatch({
        type: GET_RESTAURANT_INFO,
        payload: restaurant_info,
      });
    })
    .catch(function (error) {
      console.error(error);
    });
};

export const getRestaurantInfoForLoggedInUser = (slug) => (
  dispatch,
  getState
) => {
  const sequence = beginRestaurantInfoRequest();
  const user = getState().user.user;
  const payload = {
    token: user.data.auth_token,
    user_id: user.data.id,
  };
  attachCustomerCoords(payload, user);

  return Axios.post(GET_FAVORITE_RESTAURANT_FOR_LOGGED_IN_URL + "/" + slug, payload)
    .then((response) => {
      const restaurant_info = response.data;
      if (!isLatestRestaurantInfoRequest(sequence)) {
        return null;
      }
      return dispatch({
        type: GET_RESTAURANT_INFO_FOR_LOGGED_IN_USER,
        payload: restaurant_info,
      });
    })
    .catch(function (error) {
      console.error(error);
    });
};

export const getRestaurantInfoById = (id, lat, lng) => (dispatch, getState) => {
  const sequence = beginRestaurantInfoRequest();
  const stateUser = getState().user.user;
  const payload = attachCustomerCoords({}, stateUser, lat, lng);

  // Only include user_id when logged in - allow guests to fetch store info too
  if (stateUser && stateUser.data && stateUser.data.id) {
    payload.user_id = stateUser.data.id;
  }

  return Axios.post(GET_RESTAURANT_INFO_BY_ID_URL + "/" + id, payload)
    .then((response) => {
      const restaurant_info = response.data;
      if (!isLatestRestaurantInfoRequest(sequence)) {
        // Multi-vendor callers still need this response for local charge
        // calculations; only suppress its write to shared restaurant_info.
        return restaurant_info;
      }
      dispatch({
        type: GET_RESTAURANT_INFO_BY_ID,
        payload: restaurant_info,
      });
      return restaurant_info;
    })
    .catch(function (error) {
      console.error(error);
    });
};

export const getRestaurantItems = (slug) => (dispatch, getState) => {
  // Check if user exists and has auth data before using it
  const state = getState();
  const user = state.user && state.user.user ? state.user.user : null;

  // Get current cart type from app mode or user state
  const cartType = getCurrentCartType(getState);

  // Prepare payload - handle cases where user is not logged in (guest browsing)
  const payload = {
    cart_type: cartType
  };

  if (user && user.data && user.data.auth_token) {
    payload.token = user.data.auth_token;
    payload.user_id = user.data.id;
  }
  // For guests, payload will have cart_type but no auth - backend handles this

  Axios.post(GET_RESTAURANT_ITEMS_URL + "/" + slug, payload)
    .then((response) => {
      const restaurant_items = response.data || {};
      if (!restaurant_items.items || typeof restaurant_items.items !== "object") {
        restaurant_items.items = {};
      }

      // Support 2-level (parent -> sub -> items) and 3-level (parent -> sub -> sub_sub -> items)
      Object.keys(restaurant_items.items).forEach((parentCategory) => {
        const subData = restaurant_items.items[parentCategory];
        if (!subData || typeof subData !== "object") return;
        Object.keys(subData).forEach((subcategory) => {
          const data = subData[subcategory];
          if (Array.isArray(data)) {
            data.forEach((item) => { item.desc = ""; });
          } else if (data && typeof data === "object") {
            Object.keys(data).forEach((subSub) => {
              const arr = data[subSub];
              if (Array.isArray(arr)) arr.forEach((item) => { item.desc = ""; });
            });
          }
        });
      });
      return dispatch({
        type: GET_RESTAURANT_ITEMS,
        payload: restaurant_items,
      });
    })
    .catch(function (error) {
      // Better error handling for guest requests
      console.error("Error fetching restaurant items:", error);
      if (error.response) {
        console.error("Response status:", error.response.status);
        console.error("Response data:", error.response.data);
      } else if (error.request) {
        console.error("No response received:", error.request);
      } else {
        console.error("Error setting up request:", error.message);
      }
      // Don't throw - allow guest browsing to continue even if API fails
    });
};

export const getSingleItem = (id) => (dispatch, getState) => {
  let user = getState().user.user;

  // Get current cart type from app mode or user state
  const cartType = getCurrentCartType(getState);

  let payload = { token: "", user_id: "", id: id, cart_type: cartType };
  if (user && user.data) {
    payload.token = user.data.auth_token;
    payload.user_id = user.data.id;
  }
  return Axios.post(GET_SINGLE_ITEM_URL, payload)
    .then((response) => {
      const item = response.data;
      // let itemDetails = {
      //   id: item.id,
      //   desc: "",
      //   recommended: [],
      //   compare_items: [],
      //   also_bought: [],
      // };
      // if (item.desc && item.id === itemDetails.id) {
      //   itemDetails = { desc: item.desc, id: item.id };
      //   item.desc = "";
      // }
      // if (
      //   item.recommended &&
      //   item.recommended.length &&
      //   item.id === itemDetails.id
      // ) {
      //   itemDetails.recommended = item.recommended;
      //   item.recommended = [];
      // }
      // if (
      //   item.compare_items &&
      //   item.compare_items.length &&
      //   item.id === itemDetails.id
      // ) {
      //   itemDetails.compare_items = item.compare_items;
      //   item.compare_items = [];
      // }
      // if (
      //   item.also_bought &&
      //   item.also_bought.length &&
      //   item.id === itemDetails.id
      // ) {
      //   itemDetails.also_bought = item.also_bought;
      //   item.also_bought = [];
      // }

      dispatch({
        type: SINGLE_ITEM,
        payload: item.id,
      });
      return item;
    })
    .catch(function (error) {
      // Handle 404 if item mode doesn't match cart type
      if (error.response && error.response.status === 404) {
        const errorData = error.response.data;
        if (errorData && errorData.message && errorData.message.includes('not available for the selected delivery mode')) {
          console.warn('Item not available for current delivery mode:', errorData.message);
          // Return error object so component can handle it
          return Promise.reject({
            type: 'MODE_MISMATCH',
            message: errorData.message || 'This item is not available for the selected delivery mode.',
            itemMode: errorData.item_mode,
            cartType: cartType
          });
        }
      }
      console.error(error);
      return Promise.reject(error);
    });
};

export const resetItems = () => (dispatch) => {
  const empty = [];
  return dispatch({ type: RESET_ITEMS, payload: empty });
};
// export const resetBackup = () => (dispatch) => {
//   const empty = [];
//   return dispatch({ type: RESET_BACKUP, payload: empty });
// };

export const resetInfo = () => (dispatch) => {
  // Invalidate any Store/Cart request that started before this reset.
  beginRestaurantInfoRequest();
  const empty = [];
  return dispatch({ type: RESET_INFO, payload: empty });
};

export const searchItem = (
  itemList,
  itemName,
  searchFoundText,
  noResultText
) => (dispatch, getState) => {
  const searchResultText = searchFoundText + itemName;
  const noSearchFoundText = noResultText + itemName;

  let foodItems = [];

  foodItems = itemList.filter((eachItem) => {
    const itemNames = eachItem.name.toLowerCase();
    return itemNames.includes(itemName.toLowerCase());
  });

  //console.log("searchResult", searchResult);

  // const searcher = new FuzzySearch(itemList, ["name"], {
  //   caseSensitive: false,
  // });

  //foodItems = searcher.search(itemName);

  if (foodItems.length > 0) {
    return dispatch({
      type: SEARCH_ITEM,
      payload: { items: { [searchResultText]: { "": foodItems } } },
    });
  } else if (foodItems.length <= 0) {
    return dispatch({
      type: SEARCH_ITEM,
      payload: { items: { [noSearchFoundText]: { "": foodItems } } },
    });
  }
};

export const sortItems = (itemList, selectedOption) => (dispatch) => {
  let store = [...itemList];
  if (selectedOption === "2") {
    store.sort(
      (a, b) => parseFloat(b.price.toString()) - parseFloat(a.price.toString())
    );
  } else if (selectedOption === "3") {
    store.sort(
      (a, b) => parseFloat(a.price.toString()) - parseFloat(b.price.toString())
    );
  }
  if (selectedOption === "2") {
    const highToLow = "Price - High to Low";
    return dispatch({
      type: SEARCH_ITEM,
      payload: { items: { [highToLow]: { "": store } } },
    });
  } else if (selectedOption === "3") {
    const lowToHigh = "Price - Low to High";
    return dispatch({
      type: SEARCH_ITEM,
      payload: { items: { [lowToHigh]: { "": store } } },
    });
  }
};

export const clearSearch = (data) => (dispatch) => {
  return dispatch({ type: CLEAR_SEARCH, payload: data });
};

export const setFavoriteRest = (token, rest_id, type) => (dispatch) => {
  const requestConfig = token
    ? { headers: { Authorization: `Bearer ${token}` } }
    : {};
  return Axios.post(
    ADD_TO_FAVORITE_RESTAURANT_URL,
    {
      token: token,
      id: rest_id,
      type: type,
    },
    requestConfig
  )
    .then((response) => {
      const restaurant = response.data;
      if (type === "restaurant") {
        // Payload is merged in the reducer so eta_label / distance are preserved.
        return dispatch({
          type: SET_FAVORITE_REST,
          payload: restaurant,
        });
      }
    })
    .catch(function (error) {
      console.error('Toggle favorite API error:', error);
    });
};

export const mappedRestaurant = (token, rest_id, type) => (
  dispatch,
  getState
) => {
  return Axios.post(ADD_TO_MAPPED_RESTAURANT_URL, {
    token: token,
    action: type,
    restaurant_id: rest_id,
  })
    .then((response) => {
      const state = getState();
      // console.log(state);
      const cartProducts = state.cart.products;
      for (let i = cartProducts.length - 1; i >= 0; i--) {
        // remove all items from cart
        cartProducts.splice(i, 1);
      }

      dispatch(updateCart(cartProducts));

      const data = response.data;
      dispatch({ type: SET_MAPPED_REST, payload: data });
      return data;
    })
    .catch(function (error) {
      console.error(error);
    });
};

export const getHomeProducts = (latitude, longitude, state, appMode = 1, shuffle = true) => {
  return async (dispatch) => {
    try {
      // console.log('🔥 API Call with App Mode:', `${GET_HOME_PRODUCTS_URL}?latitude=${latitude}&longitude=${longitude}&state=${state}&app_mode=${appMode}&shuffle=${shuffle}`);

      const response = await Axios.get(
        `${GET_HOME_PRODUCTS_URL}?latitude=${latitude}&longitude=${longitude}&state=${state}&app_mode=${appMode}&shuffle=${shuffle}`
      );

      // console.log('🔥 Raw API Response:', response.data);

      if (response.data && response.data.success && response.data.tagged_items) {
        // Validate and ensure exactly 6 items per tag
        const validateAndLimitItems = (items, tagName) => {
          if (!Array.isArray(items)) {
            console.warn(`⚠️ ${tagName} is not an array:`, items);
            return [];
          }

          // Take exactly 6 items and validate each one
          const validItems = items
            .slice(0, 6) // Strictly limit to 6
            .filter((item, index) => {
              const isValid = (
                item &&
                typeof item === 'object' &&
                typeof item.id === 'number' &&
                typeof item.name === 'string' &&
                typeof item.image === 'string' &&
                typeof item.price === 'number' &&
                item.name.trim() !== '' &&
                item.image.trim() !== ''
              );

              if (!isValid) {
                console.warn(`⚠️ Invalid item at index ${index} in ${tagName}:`, item);
              }

              return isValid;
            });

          // console.log(`✅ ${tagName}: ${validItems.length} valid items out of ${items.length} total`);
          return validItems;
        };

        const processedData = {
          ...response.data,
          tagged_items: {
            is_new: validateAndLimitItems(response.data.tagged_items.is_new || [], 'is_new'),
            is_top_picks: validateAndLimitItems(response.data.tagged_items.is_top_picks || [], 'is_top_picks'),
            is_popular: validateAndLimitItems(response.data.tagged_items.is_popular || [], 'is_popular')
          }
        };

        // console.log('🔥 Processed Data:', processedData);
        // console.log('🔥 Final counts:', {
        //   is_new: processedData.tagged_items.is_new.length,
        //   is_top_picks: processedData.tagged_items.is_top_picks.length,
        //   is_popular: processedData.tagged_items.is_popular.length
        // });

        dispatch({
          type: GET_HOME_PRODUCTS,
          payload: processedData
        });
      } else {
        // console.error('❌ Invalid API response structure:', response.data);
        dispatch({
          type: GET_HOME_PRODUCTS,
          payload: {
            success: false,
            master_items: [],
            tagged_items: {
              is_new: [],
              is_top_picks: [],
              is_popular: []
            }
          }
        });
      }
    } catch (error) {
      // console.error("❌ Error fetching home products:", error);
      dispatch({
        type: GET_HOME_PRODUCTS,
        payload: {
          success: false,
          master_items: [],
          tagged_items: {
            is_new: [],
            is_top_picks: [],
            is_popular: []
          }
        }
      });
    }
  };
};

export const getShowMoreProducts = (latitude, longitude, state, tag, page, limit = 6) => {
  return async (dispatch) => {
    try {
      // Build API URL using the configured endpoint
      const apiUrl = `${GET_SHOW_MORE_PRODUCTS_URL}?latitude=${latitude}&longitude=${longitude}&state=${state}&tag=${tag}&page=${page}&limit=${limit}`;

      // console.log('🔥 Show More API Call:', apiUrl);

      const response = await Axios.get(apiUrl);

      // console.log('🔥 Show More API Response:', response.data);

      if (response.data && response.data.success) {
        // Validate items from API response
        const validateItems = (items, tagName) => {
          if (!Array.isArray(items)) {
            console.warn(`⚠️ ${tagName} is not an array:`, items);
            return [];
          }

          const validItems = items.filter((item, index) => {
            const isValid = (
              item &&
              typeof item === 'object' &&
              typeof item.id === 'number' &&
              typeof item.name === 'string' &&
              typeof item.image === 'string' &&
              typeof item.price === 'number' &&
              item.name.trim() !== '' &&
              item.image.trim() !== ''
            );

            if (!isValid) {
              console.warn(`⚠️ Invalid show more item at index ${index} in ${tagName}:`, item);
            }

            return isValid;
          });

          // console.log(`✅ Show More ${tagName}: ${validItems.length} valid items out of ${items.length} total`);
          return validItems;
        };

        // Extract items for the specific tag - API returns items directly under the tag key
        const tagItems = response.data[tag] || [];
        const validatedItems = validateItems(tagItems, tag);

        // Since the API might return all items, we need to implement client-side pagination
        // Calculate the items for the requested page
        const startIndex = (page - 1) * limit;
        const endIndex = startIndex + limit;
        const paginatedItems = validatedItems.slice(startIndex, endIndex);

        // console.log(`🔥 Pagination: Page ${page}, Start: ${startIndex}, End: ${endIndex}`);
        // console.log(`🔥 Total items from API: ${validatedItems.length}, Paginated items: ${paginatedItems.length}`);

        const processedData = {
          success: true,
          tag: tag,
          page: page,
          items: paginatedItems,
          total_items: paginatedItems.length,
          total_available: validatedItems.length
        };

        // console.log('🔥 Show More Processed Data:', processedData);

        dispatch({
          type: GET_SHOW_MORE_PRODUCTS,
          payload: processedData
        });

        return processedData;
      } else {
        console.error('❌ Invalid Show More API response structure:', response.data);
        const errorData = {
          success: false,
          tag: tag,
          page: page,
          items: [],
          total_items: 0
        };

        dispatch({
          type: GET_SHOW_MORE_PRODUCTS,
          payload: errorData
        });

        return errorData;
      }
    } catch (error) {
      console.error("❌ Error fetching show more products:", error);
      const errorData = {
        success: false,
        tag: tag,
        page: page,
        items: [],
        total_items: 0,
        error: error.message
      };

      dispatch({
        type: GET_SHOW_MORE_PRODUCTS,
        payload: errorData
      });

      return errorData;
    }
  };
};

export const getPriceSortedProducts = (latitude, longitude, state, sortOrder = 'desc') => {
  return async (dispatch) => {
    try {
      // Handle clearing the data when null parameters are passed
      if (!latitude || !longitude || !state || !sortOrder) {
        // console.log('💰 Clearing price sorted data');
        dispatch({
          type: GET_PRICE_SORTED_PRODUCTS,
          payload: {
            success: false,
            master_items: [],
            tagged_items: { is_top_picks: [], is_new: [], is_popular: [] }
          }
        });
        return {
          success: false,
          master_items: [],
          tagged_items: { is_top_picks: [], is_new: [], is_popular: [] }
        };
      }

      const apiUrl = `${GET_PRICE_SORTED_PRODUCTS_URL}?latitude=${latitude}&longitude=${longitude}&state=${state}&sort_by=price&sort_order=${sortOrder}`;

      // console.log('💰 Price Sorted API Call:', apiUrl);

      const response = await Axios.get(apiUrl);

      // console.log('💰 Price Sorted API Response:', response.data);

      if (response.data && response.data.success && response.data.tagged_items) {
        // Validate tagged_items from API response
        const validateTaggedItems = (taggedItems) => {
          if (!taggedItems || typeof taggedItems !== 'object') {
            console.warn('⚠️ Tagged items is not an object:', taggedItems);
            return { is_top_picks: [], is_new: [], is_popular: [] };
          }

          const validatedTags = {};
          ['is_top_picks', 'is_new', 'is_popular'].forEach(tag => {
            const items = taggedItems[tag];
            if (!Array.isArray(items)) {
              console.warn(`⚠️ ${tag} is not an array:`, items);
              validatedTags[tag] = [];
            } else {
              const validItems = items.filter((item, index) => {
                const isValid = (
                  item &&
                  typeof item === 'object' &&
                  typeof item.id === 'number' &&
                  typeof item.name === 'string' &&
                  typeof item.image === 'string' &&
                  typeof item.price === 'number' &&
                  item.name.trim() !== '' &&
                  item.image.trim() !== ''
                );

                if (!isValid) {
                  console.warn(`⚠️ Invalid item in ${tag} at index ${index}:`, item);
                }

                return isValid;
              });

              // console.log(`✅ ${tag}: ${validItems.length} valid items out of ${items.length} total`);
              validatedTags[tag] = validItems;
            }
          });

          return validatedTags;
        };

        const validatedTaggedItems = validateTaggedItems(response.data.tagged_items);

        const processedData = {
          success: true,
          master_items: response.data.master_items || [],
          tagged_items: validatedTaggedItems,
          sort_by: response.data.sort_by || 'price',
          sort_order: response.data.sort_order || sortOrder,
          total_items: (response.data.master_items || []).length
        };

        // console.log('💰 Price Sorted Processed Data:', processedData);
        // console.log('💰 Tagged items breakdown:');
        // console.log('  - Top Picks:', processedData.tagged_items.is_top_picks.length, 'items');
        // console.log('  - New:', processedData.tagged_items.is_new.length, 'items');
        // console.log('  - Popular:', processedData.tagged_items.is_popular.length, 'items');

        dispatch({
          type: GET_PRICE_SORTED_PRODUCTS,
          payload: processedData
        });

        return processedData;
      } else {
        console.error('❌ Invalid Price Sorted API response structure:', response.data);
        const errorData = {
          success: false,
          master_items: [],
          tagged_items: { is_top_picks: [], is_new: [], is_popular: [] },
          sort_by: 'price',
          sort_order: sortOrder,
          total_items: 0,
          error: response.data.error || 'Unknown error'
        };

        dispatch({
          type: GET_PRICE_SORTED_PRODUCTS,
          payload: errorData
        });

        return errorData;
      }
    } catch (error) {
      console.error("❌ Error fetching price sorted products:", error);
      const errorData = {
        success: false,
        master_items: [],
        tagged_items: { is_top_picks: [], is_new: [], is_popular: [] },
        sort_by: 'price',
        sort_order: sortOrder,
        total_items: 0,
        error: error.message
      };

      dispatch({
        type: GET_PRICE_SORTED_PRODUCTS,
        payload: errorData
      });

      return errorData;
    }
  };
};

export const getPriceSortedShowMoreProducts = (latitude, longitude, state, tag, page, sortOrder, limit = 6) => {
  return async (dispatch) => {
    try {
      // Build API URL using the configured endpoint with price sorting parameters
      const apiUrl = `${GET_PRICE_SORTED_SHOW_MORE_PRODUCTS_URL}?latitude=${latitude}&longitude=${longitude}&state=${state}&tag=${tag}&sort_by=price&sort_order=${sortOrder}&page=${page}&limit=${limit}`;

      const response = await Axios.get(apiUrl);

      if (response.data && response.data.success) {
        // Validate items from API response - same validation as regular show more
        const validateItems = (items, tagName) => {
          if (!Array.isArray(items)) {
            console.warn(`⚠️ ${tagName} is not an array:`, items);
            return [];
          }

          const validItems = items.filter((item, index) => {
            const isValid = (
              item &&
              typeof item === 'object' &&
              typeof item.id === 'number' &&
              typeof item.name === 'string' &&
              typeof item.image === 'string' &&
              typeof item.price === 'number' &&
              item.name.trim() !== '' &&
              item.image.trim() !== ''
            );

            if (!isValid) {
              console.warn(`⚠️ Invalid price sorted show more item at index ${index} in ${tagName}:`, item);
            }

            return isValid;
          });

          return validItems;
        };

        // Extract items for the specific tag - API returns items directly under the tag key
        const tagItems = response.data[tag] || [];
        const validatedItems = validateItems(tagItems, tag);

        // IMPORTANT: The API returns ALL items, but we need to implement client-side pagination
        // because the backend is not implementing proper pagination yet.
        // 
        // Page 1: Items 0-5 (handled by initial homeProducts call)
        // Page 2: Items 6-11 (this is what we want for first "Show More" click)
        // Page 3: Items 12-17 (for subsequent "Show More" clicks)

        const itemsToSkip = (page - 1) * limit; // For page 2: skip first 6 items (0-5)
        const paginatedItems = validatedItems.slice(itemsToSkip, itemsToSkip + limit);

        const processedData = {
          success: true,
          tag: tag,
          page: page,
          items: paginatedItems, // Use paginated items, not all items
          total_items: paginatedItems.length,
          total_available: validatedItems.length,
          has_more: (itemsToSkip + limit) < validatedItems.length,
          sort_by: 'price',
          sort_order: sortOrder
        };

        dispatch({
          type: GET_PRICE_SORTED_SHOW_MORE_PRODUCTS,
          payload: processedData
        });

        return processedData;
      } else {
        console.error('❌ Invalid Price Sorted Show More API response structure:', response.data);
        const errorData = {
          success: false,
          tag: tag,
          page: page,
          items: [],
          total_items: 0,
          sort_by: 'price',
          sort_order: sortOrder
        };

        dispatch({
          type: GET_PRICE_SORTED_SHOW_MORE_PRODUCTS,
          payload: errorData
        });

        return errorData;
      }
    } catch (error) {
      console.error("❌ Error fetching price sorted show more products:", error);
      const errorData = {
        success: false,
        tag: tag,
        page: page,
        items: [],
        total_items: 0,
        sort_by: 'price',
        sort_order: sortOrder,
        error: error.message
      };

      dispatch({
        type: GET_PRICE_SORTED_SHOW_MORE_PRODUCTS,
        payload: errorData
      });

      return errorData;
    }
  };
};
